import { createAction, props } from "@ngrx/store";
import { SfhFinancialDetailsFormV1 } from "./state";

export const ResetComponentStateAction = createAction('[Severe financial hardship financial details v1 component] reset state');
export const SetFormDataAction = createAction('[Severe financial hardship financial details v1 component] set sfh financial data form data', props<{financialDetails: SfhFinancialDetailsFormV1}>())
